import { classNames } from "utils/helper/helper";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isDefault?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  isDefault = true,
  className = "",
  ...props
}) => {
  const buttonClass = classNames(
    className,
    "uppercase flex justify-center relative items-center text-sm px-6",
    isDefault ? "text-white" : "border border-orange-600",
    props.disabled ? "text-white bg-orange-100" : "",
    className.includes("bg-") || !isDefault || props.disabled
      ? "h-[40px] rounded-[5px]"
      : "default-button",
    "shadow-[0_4px_9px_-4px_rgba(0,0,0,0.2)] transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:outline-none focus:ring-0 active:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)]"
  );
  return (
    <button
      className={buttonClass}
      {...props}>
      {children}
    </button>
  );
};
export const BottonLoader = ({ ...props }) => (
    <button
      className="mb-3 inline-block w-full rounded px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_rgba(0,0,0,0.2)] transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)] focus:outline-none focus:ring-0 active:shadow-[0_8px_9px_-4px_rgba(0,0,0,0.1),0_4px_18px_0_rgba(0,0,0,0.2)]"
      {...props}>
      <div role="status">
        <svg
          aria-hidden="true"
          className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-orange-400"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
    </button>
  ),
  SocialButton: React.FC<ButtonProps> = ({
    children,
    className = "",
    ...props
  }) => {
    return (
      <button
        {...props}
        className={classNames(
          "w-full py-2 px-3 inline-flex justify-center items-center gap-2 rounded-sm border",
          "bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-0",
          "focus:ring-offset-0 focus:ring-offset-white focus:ring-primary transition-all text-[14px] dark:bg-transparent",
          "dark:hover:bg-black/20 dark:border-white/10 dark:text-white/70 dark:hover:text-white dark:focus:ring-offset-white/10"
        )}>
        {children}
      </button>
    );
  },
  PrimaryButton: React.FC<ButtonProps> = ({ children, ...props }) => (
    <button
      {...props}
      className={classNames(
        "w-full text-white btn bg-orange-600 border-orange-600 font-bold",
        "hover:text-white hover:bg-orange-700 hover:border-orange-700",
        "focus:text-white focus:bg-orange-700 focus:border-orange-700 focus:ring ",
        "focus:ring-orange-100 active:text-white active:bg-orange-700 active:border-orange-700",
        "active:ring active:ring-orange-100 dark:ring-orange-400/20"
      )}>
      {children}
    </button>
  );

export default Button;
